export default __webpack_public_path__ + "static/media/managment.1fc3bf31.png";